const primaryColor = '#005c42';

const theme = {
  colors: {
    general: {
      PRIMARY: primaryColor,
      SECONDARY: '#ffffff',
      WHITE: '#ffffff',
      LIGHT: '#f8f8f8',
      SOFT_GRAY: '#dee2e6',
      NONE: 'transparent',
    },
    text: {
      HIGHLIGHT: primaryColor,
      NORMAL: '#3c4858',
      SOFT: '#686b6e',
      WHITE: '#ffffff',
      DANGER: '#f44336',
    }
  },
  units: {
    spacing: {
      NONE: '0px',
      NANO: '4px',
      MICRO: '8px',
      SMALL: '16px',
      NORMAL: '32px',
      LARGE: '64px',
      XLARGE: '128px',
      XXLARGE: '256px',
      XXXLARGE: '512px',
    },
    sizes: {
      BORDER_RADIUS: '3px',
      LARGE_BORDER_RADIUS: '9px',
      ELEMENT_SMALL: '32px',
      ELEMENT_NORMAL: '48px',
      ELEMENT_LARGE: '80px',
      ELEMENT_XLARGE: '120px',
    }
  }
};

export default theme;